var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkopen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3.5C1.83579 3.5 1.5 3.83579 1.5 4.25V12.75C1.5 13.1642 1.83579 13.5 2.25 13.5H10.75C11.1642 13.5 11.5 13.1642 11.5 12.75V8.75C11.5 8.33579 11.8358 8 12.25 8C12.6642 8 13 8.33579 13 8.75V12.75C13 13.9926 11.9926 15 10.75 15H2.25C1.00736 15 0 13.9926 0 12.75V4.25C0 3.00736 1.00736 2 2.25 2H7.25C7.66421 2 8 2.33579 8 2.75C8 3.16421 7.66421 3.5 7.25 3.5H2.25Z",
    fill: "#A7C1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19385 10.7532C4.47175 11.0603 4.94603 11.0841 5.25319 10.8062L14.5 2.43999V5.25C14.5 5.66421 14.8358 6 15.25 6C15.6642 6 16 5.66421 16 5.25V0.75C16 0.335787 15.6642 0 15.25 0H10.75C10.3358 0 10 0.335787 10 0.75C10 1.16421 10.3358 1.5 10.75 1.5H13.3032L4.24682 9.69385C3.93966 9.97175 3.91595 10.446 4.19385 10.7532Z",
    fill: "#A7C1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkopen);
export default __webpack_public_path__ + "static/media/linkopen.3c79fb0c4dbae60601d66df495c1f7df.svg";
export { ForwardRef as ReactComponent };